import React, { Component } from 'react';
import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'
import { withRouter } from 'react-router-dom';
import MaterialTable from "material-table";
import { forwardRef } from 'react';
import classNames from 'classnames';
import compose from 'recompose/compose';
// Material helpers
import { withStyles } from '@material-ui/core/styles';

import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';

import { api_host, api_auth } from '../../../../common/globals/constants';

import CircularProgress from '@material-ui/core/CircularProgress';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import NativeSelect from '@material-ui/core/NativeSelect';
import InputLabel from '@material-ui/core/InputLabel';

// Shared components
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletLabel from 'components/PortletLabel';
import PortletContent from 'components/PortletContent';
import PortletFooter from 'components/PortletFooter';

import IconButton from '@material-ui/core/IconButton';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Close';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import moment from 'moment'
import 'moment/locale/es'  
import { Button } from '@material-ui/core';

import ManageObjective from '../ManageObjective';
// Component styles
import styles from './styles';
moment.locale('es')

const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};


class ListObjectives extends Component {

    constructor(props) {
        super(props);
        this.state = {
            currentObjectiveId: this.props.match.params.objetivo_id,
            prevObjectiveId: this.props.match.params.objetivo_id,
            loadObjectiveData: false,
            externalData: null,
            dataError: false,
            isLoading: true,
            sla: null,
            time: 'h',
            step: null,
            hoverData: null,
            lastEvent: [],
            //statePeriod: this.props.params.statePeriod,
            isStatePeriod: false,
            rows: null,
            noMonCum: null,
            downCum: null,
            //date: this.props.params.date,
            dateMoment: ((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a")),
            addEl: null,
            editEl: null,
            deleteEl: null,
            values: {

            },
            open: false,
            isValid: false,
            validEmail: false,
            validName: false,
            //isRefresh: this.props.params.isRefresh,
            listObjectives: this.props.objectivesList
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        return null;
    }


    componentDidMount() {
        this.processData();
    }

    componentDidUpdate(prevProps, prevState) {}
    componentWillUnmount() {}

   

    // Helper para procesar la data de la petición a la API

    processData = () => {
        const {listObjectives} = this.state

        let arrayRowsObjectives = []
        let intervals = []
        let token = sessionStorage.getItem('key')
        Promise.all([
            fetch(api_host+`/reporte/general/intervalos_y_zona_horaria/?token=${token}`)
        ])
            .then(([res1]) => {
                return Promise.all([res1.json()])
            })
            .then(([res1]) => {
                intervals = res1
                Object.keys(listObjectives).map((key0)=> {
                    let arrayObjetives = listObjectives[key0]
                    if (key0 != 'Services' && key0 != 'ServicesUnified') {
                        Object.keys(arrayObjetives).map((key1)=> { 
                            let rows = {}
                            rows['id'] = arrayObjetives[key1].objetivo_id
                            rows['nombre'] = arrayObjetives[key1].nombre  
                            rows['descripcion'] = arrayObjetives[key1].descripcion  
                            rows['servicio'] = arrayObjetives[key1].nombre_servicio_unificado  
                            rows['intervalo'] = arrayObjetives[key1].intervalo  
                            rows['intervalo_id'] = arrayObjetives[key1].intervalo_id 
                            rows['servicio_id'] = arrayObjetives[key1].servicio_id
                            rows['nodos'] = arrayObjetives[key1].Nodos
                            rows['pasos'] = arrayObjetives[key1].Pasos
                            arrayRowsObjectives.push(rows)
                        })
                    }   
                })
                this.setState({
                    //rows : arrayRows,
                    rows: arrayRowsObjectives,
                    intervals: res1, 
                    //noMonCum : noMonCumDate,
                    //downCum : downCumDate,
                    isLoading: false,
                    //time: period,
                    //step: step,
                    dataError: false,
                }); 
            }); 
       
    }
    handleShowAdd = event => {
        this.setState({
            addEl: event.currentTarget,
            values:{
                type: 2,
            }
        });
    };

    handleCloseAdd = () => {
        this.setState({
            addEl: null,
            validEmail: false,
            validName: false,
        });
    };

    handleShowEdit = (event, value) => {
        this.setState({
            editEl: event.currentTarget,
            values:{
                descriptionEdit: value.descripcion,
                intervalEdit: value.intervalo,
                serviceEdit: value.servicio,
                nameEdit: value.nombre,
                objidEdit: value.id,
                serviceidEdit: value.servicio_id,
                intervalidEdit: value.intervalo_id,
                nodesEdit: value.nodos,
                stepEdit: value.pasos
            }
        });
    };

    handleCloseEdit = () => {
        this.setState({
            editEl: null,
            validEmail: false,
            validName: false,
        });
    };

    handleShowDelete = (event, value) => {
        this.setState({
            deleteEl: event.currentTarget,
            values:{
                name: value.nombre,
                addresseeId: value.notificacionDestinatarioId
            }
        });
    };
    handleCloseDelete = () => {
        this.setState({
            deleteEl: null
        });
    };

    handleFieldChange = (field, value) => {
        const newState = { ...this.state };
        newState.values[field] = value;     
        this.setState(newState);
    };


    handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          	return;
        }
        this.setState({
            open: false 
        })
    };

    render() {
        const { classes, className, ...rest } = this.props;
        const { dataError, isLoading, rows, noMonCum, downCum, addEl, editEl, deleteEl, open, isValid, validEmail, validName, values, intervals} = this.state;
        const {destinyEdit, nameEdit, phoneEdit, typeEdit, name } = this.state.values
        const style = isLoading ? { display: 'none' } : {};
        const styleHidden = isLoading ? {} : { display: 'none' };    
        const showAddEl = Boolean(addEl);   
        const showEditEl = Boolean(editEl); 
        const showDeleteEl = Boolean(deleteEl); 
        const rootClassName = classNames(classes.root, className);
  
        if (!dataError) {
            return (<FormattedChart classes={classes} rows={rows} noMonCum={noMonCum} downCum={downCum} isLoading={isLoading} style={style} styleHidden={styleHidden}
                                    handleCloseAdd={this.handleCloseAdd} handleShowAdd={this.handleShowAdd} showAddEl={showAddEl}
                                    handleFieldChange={this.handleFieldChange}
                                    handleCloseEdit={this.handleCloseEdit} handleShowEdit={this.handleShowEdit} showEditEl={showEditEl} 
                                    destinyEdit={destinyEdit} nameEdit={nameEdit} phoneEdit={phoneEdit} typeEdit={typeEdit}
                                    handleDeleted={this.handleDeleted} 
                                    open={open} isValid={isValid} handleClose={this.handleClose}
                                    handleCloseDelete={this.handleCloseDelete} handleShowDelete={this.handleShowDelete} showDeleteEl={showDeleteEl}
                                    name={name} validEmail={validEmail} validateEmail={this.validateEmail} 
                                    validName={validName} validateName={this.validateName}
                                    values={values} intervals={intervals}/>) 
        }
        else if (dataError) {
            return (<p>No hay datos..</p>)
        }
        else return (<p> Error!</p >)

    }
}

function FormattedChart(props) {
    return (
        <div>
            { props.rows == null  ? 
                <PortletContent>

                        <Typography
                        variant="h5"
                        align="center"
                        >
                        <CircularProgress
                        variant="indeterminate"

                        size={24}
                        thickness={4}
                        
                        />
                        <br/>
                        Cargando Información...
                    </Typography>
                </PortletContent>
            :
                <div style={{ maxWidth: "100%", marginTpo:'105px'  }}>
                    {/*<Button style={{backgroundColor: 'white'}} variant="outlined" color="primary" size="small">
                        <Typography variant="button"> Agregar contacto </Typography>
                    </Button>*/}
                    <MaterialTable
                        
                        icons={tableIcons}
                        columns={[
                            { width: 100, title: "Nombre", field: "nombre"/*, defaultGroupOrder: 0*/,headerStyle: {
                                backgroundColor: '#6d6d6d',
                                color: '#FFF'
                              } },
                            { width: 100, title: "Descripción", field: "descripcion" ,headerStyle: {
                                backgroundColor: '#6d6d6d',
                                color: '#FFF'
                              } },
                            { width: 100, title: "Servicio", field: "servicio"/*, type: "numeric"*/ ,headerStyle: {
                                backgroundColor: '#6d6d6d',
                                color: '#FFF'
                              } },
                            { width: 100, title: "Editar", field: "editar"/*, type: "numeric"*/,headerStyle: {
                                backgroundColor: '#979797',
                                color: '#FFF'
                              }, hidden: true },
                            { width: 100, title: "Intervalo", field: "intervalo"/*, type: "numeric"*/,headerStyle: {
                                backgroundColor: '#979797',
                                color: '#FFF'
                              }, hidden: true },
                            { width: 100, title: "Intervalo_id", field: "intervalo_id"/*, type: "numeric"*/,headerStyle: {
                                backgroundColor: '#039be5',
                                color: '#FFF'
                              }, hidden: true },
                            { width: 100, title: "Nodos", field: "nodos"/*, type: "numeric"*/,headerStyle: {
                                backgroundColor: '#979797',
                                color: '#353535'
                              }, hidden: true },
                            { width: 100, title: "Pasos", field: "pasos"/*, type: "numeric"*/,headerStyle: {
                                backgroundColor: '#979797',
                                color: '#353535'
                              }, hidden: true },
                            
                        ]}
                        /*data={[
                            { monitor: "Claro (cl)", paso: "Home", minimo: 0.320, maximo: 22.700, promedio: 2.590, uptime: 100.000, downtime: 0.000, nomon: 0.000, total: 213  },
                            { monitor: "Claro (cl)", paso: "Login", minimo: 0.320, maximo: 22.700, promedio: 2.590, uptime: 100.000, downtime: 0.000, nomon: 0.000, total: 213  },
                            { monitor: "Claro (cl)", paso: "Liquidaciones", minimo: 0.320, maximo: 22.700, promedio: 2.590, uptime: 100.000, downtime: 0.000, nomon: 0.000, total: 213  },
                            { monitor: "Entel (cl)", paso: "Home", minimo: 0.280, maximo: 4.580, promedio: 2.470, uptime: 99.530, downtime: 0.470, nomon: 0.000, total: 213  }
                        ]}*/
                        data={props.rows} 
                        //title="• Los contactos solo pueden ser eliminados cuando no están asociados a alertas."
                        title=" "
                        localization={{
                            grouping: {
                                groupedBy: 'Agrupar por:',
                                placeholder: 'Arrastre los encabezados aquí, para agrupar',
                            },
                            body: {
                                emptyDataSourceMessage: 'No hay datos'
                            },
                            toolbar: {
                                searchTooltip: 'Buscar',
                                searchPlaceholder: 'Buscar'
                            },
                            pagination: {
                                labelRowsSelect: 'Filas',
                                labelDisplayedRows: ' {from}-{to} de {count}',
                                firstTooltip: 'Pri. pág.',
                                previousTooltip: 'Pág. previa',
                                nextTooltip: 'Sig. pág.',
                                lastTooltip: 'Últ. pág'
                            },
                            header: {
                                actions: '',
                                headerStyle: {
                                    backgroundColor: '#e7e7e7',
                                    color: '#FFF'
                                }
                            },
                        }}
                        options={{
                            grouping: true,
                            actionsColumnIndex: -1,
                            actionsColumnIndex: -1,
                            headerStyle: {
                                backgroundColor: '#6d6d6d',
                                color: '#FFF'
                            }
                        }}
                        actions={[
                            /*{
                                icon: AddCircleOutlineIcon,
                                tooltip: 'Agregar contacto',
                                isFreeAction: true,
                                //onClick: (event) => alert("You want to add a new row")
                                onClick: props.handleShowAdd
                            },*/
                            {
                                icon: Edit,
                                tooltip: 'Editar objetivo',
                                //props.handleFieldChange('name', event.target.value)
                                //onClick: (event, rowData) => alert("You saved " + rowData.nombre)
                                onClick: (event, rowData) => props.handleShowEdit(event, rowData)
                            },
                            
                            /*rowData => ({
                                icon: DeleteOutline,
                                tooltip: 'Eliminar contacto',
                                onClick: (event, rowData) => props.handleShowDelete(event, rowData),
                                disabled: rowData.eliminar,
                                hidden: rowData.eliminar
                            })*/
                        ]}
                    />
                    <Modal
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                        open={props.showEditEl}
                        onClose={props.handleCloseEdit}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                        disableAutoFocus={true}
                        disableEnforceFocus={true}
                        closeAfterTransition
                        BackdropComponent={Backdrop}
                        BackdropProps={{
                            timeout: 500,
                        }}
                    >                                    
                        <Fade in={props.showEditEl} style={{maxWidth: 700}}>
                            <div className={props.classes.modal}>    
                                {<ManageObjective values={props.values} intervals={props.intervals} handleCloseEdit={props.handleCloseEdit}></ManageObjective>}                                              
                            </div>
                        </Fade>
                    </Modal>
    
                    
                </div>
                
            }
            </div>
        )

}

export default compose(withRouter, withStyles(styles))(ListObjectives);
